module.exports = __webpack_public_path__ + "static/form-page-banner-1920x771-ac6a882a1a1d7b91940f68f2c0b56ace.jpg";